<template>
  <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800 p-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-6">Terms & Conditions</h1>
    
    <div class="prose dark:prose-invert max-w-none">
      <p class="mb-4">Last updated: {{ new Date().toLocaleDateString() }}</p>
      
      <h2 class="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
      <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>

      <h2 class="text-2xl font-semibold mt-8 mb-4">2. Use License</h2>
      <p>Permission is granted to temporarily download one copy of the materials (information or software) on CompanyName's website for personal, non-commercial transitory viewing only.</p>

      <h2 class="text-2xl font-semibold mt-8 mb-4">3. Disclaimer</h2>
      <p>The materials on CompanyName's website are provided on an 'as is' basis. CompanyName makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

      <h2 class="text-2xl font-semibold mt-8 mb-4">4. Limitations</h2>
      <p>In no event shall CompanyName or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on CompanyName's website.</p>

      <h2 class="text-2xl font-semibold mt-8 mb-4">5. Revisions</h2>
      <p>The materials appearing on CompanyName's website could include technical, typographical, or photographic errors. CompanyName does not warrant that any of the materials on its website are accurate, complete or current.</p>
    </div>
  </div>
</template>